import { render, staticRenderFns } from "./EntitlementTableHistory.vue?vue&type=template&id=0204749f"
import script from "./EntitlementTableHistory.vue?vue&type=script&lang=js"
export * from "./EntitlementTableHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports